/**
 * @generated SignedSource<<c264255d260f3fe2c47c0d8d669b2663>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSteps_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryStep_item" | "CheckoutPaymentStepStripe_item" | "CheckoutPaymentStep_item" | "CheckoutProgressReview_item" | "CheckoutReviewStep_item">;
  readonly " $fragmentType": "CheckoutSteps_item";
};
export type CheckoutSteps_item$key = {
  readonly " $data"?: CheckoutSteps_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSteps_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSteps_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryStep_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStep_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutProgressReview_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPaymentStep_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPaymentStepStripe_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "24d4b117e7317cf027449f56532eccf2";

export default node;
